module.exports = __webpack_public_path__ + "media/images/googleanalytics-5bb769bd8b7069635d9a9c009aef2331.svg";